export {};
//# sourceMappingURL=ISprites.js.map